export default __webpack_public_path__ + "static/media/logoIcon.412c81a7.svg";